import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { STAGING_ID } from '../../../../constants/constants';
import { IBasicDetails } from '../../../../interface/interfaces';

interface IInitialState {
    stagingItemPersistent: IBasicDetails | null;
}

let initialStagingItem: IBasicDetails | null = null;

try {
    const storedStagingId = JSON.parse(localStorage.getItem(STAGING_ID) || 'null') as IBasicDetails;
    initialStagingItem = storedStagingId || null;
} catch (error) {
    initialStagingItem = null;
}

const initialState: IInitialState = {
    stagingItemPersistent: initialStagingItem,
};

const stagingItemSlice = createSlice({
    name: 'stagingItem',
    initialState,
    reducers: {
        saveStagingItem: (state: IInitialState, action: PayloadAction<IBasicDetails>) => {
            state.stagingItemPersistent = action.payload;
            localStorage.setItem(STAGING_ID, JSON.stringify(action.payload));
        },

        removeStagingItem: (state: IInitialState) => {
            state.stagingItemPersistent = null;
            localStorage.removeItem(STAGING_ID);
        },
    },
});

export default stagingItemSlice.reducer;
export const { saveStagingItem, removeStagingItem } = stagingItemSlice.actions;
